// infolayerToolbar.js
export class InfoLayerToolbar {
    constructor({ page, overlaysM, onInfoLayerChanged }) {
      this.page = page;
      this.overlaysM = overlaysM;
      this.onInfoLayerChanged = onInfoLayerChanged;
      this.activeIndex = 0;
      this.root = null;
      this.select = null;
    }
  
    mount(parentEl) {
      // Minimal styling (since your project doesn't include bootstrap)
      const style = document.createElement("style");
      style.textContent = `
        .ilbar { position:absolute; top:12px; left:12px; z-index:99999; background:rgba(0,0,0,.55);
                padding:10px; border-radius:10px; color:white; font:14px/1.2 sans-serif; user-select:none; }
        .ilbar .row { display:flex; gap:8px; align-items:center; margin-top:8px; }
        .ilbar select { padding:6px; border-radius:8px; border:1px solid rgba(255,255,255,.2); background:rgba(0,0,0,.35); color:white; }
        .ilbar button { padding:6px 10px; border-radius:8px; border:1px solid rgba(255,255,255,.2);
                        background:rgba(255,255,255,.10); color:white; cursor:pointer; }
        .ilbar button.danger { background:rgba(255,0,0,.25); border-color:rgba(255,0,0,.35); }
        .ilbar button:hover { background:rgba(255,255,255,.18); }
        .ilbar .title { font-weight:600; }
      `;
      document.head.appendChild(style);
  
      this.root = document.createElement("div");
      this.root.className = "ilbar";
  
      const title = document.createElement("div");
      title.className = "title";
      title.textContent = "InfoLayers";
      this.root.appendChild(title);
  
      const row1 = document.createElement("div");
      row1.className = "row";
  
      this.select = document.createElement("select");
      row1.appendChild(this.select);
      this.root.appendChild(row1);
  
      const row2 = document.createElement("div");
      row2.className = "row";
  
      const btnAddBefore = this._btn("Add Before");
      const btnAddAfter  = this._btn("Add After");
      const btnCopy      = this._btn("Copy");
      const btnRemove    = this._btn("Delete", true);
  
      row2.appendChild(btnAddBefore);
      row2.appendChild(btnAddAfter);
      row2.appendChild(btnCopy);
      row2.appendChild(btnRemove);
      this.root.appendChild(row2);
  
      parentEl.appendChild(this.root);
  
      // Populate select
      this.refreshSelect();
  
      // Events
      this.select.addEventListener("change", () => {
        this.activeIndex = Number(this.select.value);
        this._applyActive();
      });
  
      btnAddBefore.addEventListener("click", () => this.createInfoLayer(this.activeIndex));
      btnAddAfter.addEventListener("click", () => this.createInfoLayer(this.activeIndex + 1));
      btnCopy.addEventListener("click", () => this.copyInfoLayer(this.activeIndex));
      btnRemove.addEventListener("click", () => this.deleteInfoLayer(this.activeIndex));
  
      // default apply
      this._applyActive();
    }
  
    _btn(label, danger = false) {
      const b = document.createElement("button");
      b.textContent = label;
      if (danger) b.classList.add("danger");
      return b;
    }
  
    refreshSelect() {
      const ils = Array.isArray(this.page?.infoLayers) ? this.page.infoLayers : [];
      this.select.innerHTML = "";
      ils.forEach((il, idx) => {
        const opt = document.createElement("option");
        opt.value = String(idx);
        opt.textContent = il?.name ? `${idx}: ${il.name}` : `${idx}: ${il?.id ?? "infolayer"}`;
        this.select.appendChild(opt);
      });
      // keep within bounds
      this.activeIndex = Math.max(0, Math.min(this.activeIndex, Math.max(ils.length - 1, 0)));
      this.select.value = String(this.activeIndex);
    }
  
    _applyActive() {
      // Filter overlays
      this.overlaysM.setActiveInfoLayerIndex(this.activeIndex);
      if (this.onInfoLayerChanged) this.onInfoLayerChanged(this.activeIndex);
    }
  
    // ======== functionality matching old toolbar semantics ========
    createInfoLayer(insertIndex) {
      const ils = Array.isArray(this.page.infoLayers) ? this.page.infoLayers : (this.page.infoLayers = []);
      const newId = `infolayer_${Date.now()}`;
      const newLayer = { id: newId, name: "New InfoLayer", overlays: [] };
  
      const idx = Math.max(0, Math.min(insertIndex, ils.length));
      ils.splice(idx, 0, newLayer);
      this.activeIndex = idx;
      this.refreshSelect();
      this._applyActive();
    }
  
    copyInfoLayer(index) {
      const ils = Array.isArray(this.page.infoLayers) ? this.page.infoLayers : [];
      if (!ils[index]) return;
  
      const src = ils[index];
      const copy = structuredClone ? structuredClone(src) : JSON.parse(JSON.stringify(src));
      copy.id = `${src.id || "infolayer"}_copy_${Date.now()}`;
      copy.name = `${src.name || "InfoLayer"} (copy)`;
  
      ils.splice(index + 1, 0, copy);
      this.activeIndex = index + 1;
      this.refreshSelect();
      this._applyActive();
    }
  
    deleteInfoLayer(index) {
      const ils = Array.isArray(this.page.infoLayers) ? this.page.infoLayers : [];
      if (ils.length <= 0 || !ils[index]) return;
  
      ils.splice(index, 1);
      this.activeIndex = Math.max(0, Math.min(index, ils.length - 1));
      this.refreshSelect();
      this._applyActive();
    }
  }
  